import bg from "../assets/bg.png";
import gallery01 from "../assets/gallery01.png";
import gallery02 from "../assets/gallery02.png";
import gallery03 from "../assets/gallery03.png";
import gallery04 from "../assets/gallery04.png";
import knife from "../assets/knife.png";
import overlaybg from "../assets/overlaybg.png";
import spoon from "../assets/spoon.svg";
import welcome from "../assets/welcome.png";
import quote from "../assets/quote.png";
import logo from "../assets/logo.webp";
import bangkokpinto from "../assets/bangkokpinto.png";

export default {
  bg,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,
  logo,
  overlaybg,
  spoon,
  welcome,
  quote,
  bangkokpinto,
};
